import { render, staticRenderFns } from "./MessengerLangAnalysis.vue?vue&type=template&id=c4e8bf62&scoped=true"
import script from "./MessengerLangAnalysis.vue?vue&type=script&lang=js"
export * from "./MessengerLangAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e8bf62",
  null
  
)

export default component.exports